import { Download, Lock, CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { BuyButton } from "./BuyButton";
import { BookCover } from "./Hero";
import { PRICE_LABEL } from "@/lib/checkout";

const trust = [
    { icon: Download, label: "Download immediato" },
    { icon: Lock, label: "Pagamento sicuro" },
    { icon: CheckCircle2, label: "Accesso immediato" },
];

export const Simulator = () => (
    <section id="simulazione" className="relative bg-white py-20 sm:py-28">
        <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2">
            <Reveal>
                <h2 className="font-display text-3xl font-extrabold tracking-tight text-navy-950 sm:text-4xl lg:text-5xl">
                    Simula la prova
                    <br />
                    prima del giorno dell'esame
                </h2>
                <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-600">
                    Ogni simulazione ti permette di esercitarti su{" "}
                    <strong className="text-navy-950">40 quesiti in 60 minuti</strong>, seguendo la struttura prevista
                    per la prova. Al termine potrai controllare le risposte attraverso le{" "}
                    <strong className="text-navy-950">correzioni commentate</strong> e individuare gli argomenti da
                    approfondire con il piano di ripasso finale.
                </p>
                <div className="mt-8 flex gap-8">
                    {[
                        { v: "40", l: "quesiti per prova" },
                        { v: "60'", l: "di tempo" },
                        { v: "3", l: "prove complete" },
                    ].map((s) => (
                        <div key={s.l}>
                            <p className="font-metric text-3xl font-bold text-gold">{s.v}</p>
                            <p className="mt-1 text-[11px] uppercase tracking-wider text-slate-500">{s.l}</p>
                        </div>
                    ))}
                </div>
            </Reveal>

            <Reveal delay={0.15}>
                <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-[0_24px_60px_rgba(10,30,60,0.1)] sm:p-9">
                    <div className="flex items-center gap-5">
                        <div className="w-20 shrink-0 overflow-hidden rounded shadow-md">
                            <div className="aspect-[3/4]">
                                <BookCover small />
                            </div>
                        </div>
                        <div>
                            <h3 className="font-display text-lg font-extrabold leading-snug text-navy-950">
                                Difesa AMM 2026
                                <br />3 Simulazioni Complete
                            </h3>
                            <p className="mt-1 text-xs font-medium text-slate-500">Download digitale immediato</p>
                        </div>
                    </div>

                    <div className="mt-7 flex flex-wrap items-center gap-4 border-t border-slate-100 pt-7">
                        <span className="font-metric text-4xl font-bold text-navy-950">{PRICE_LABEL}</span>
                        <BuyButton
                            testId="second-cta-download-btn"
                            label="Ottieni le 3 simulazioni"
                            className="flex-1 !px-5"
                        />
                    </div>

                    <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2">
                        {trust.map((t) => (
                            <span key={t.label} className="inline-flex items-center gap-1.5 text-[11px] text-slate-500">
                                <t.icon className="h-3.5 w-3.5 text-gold" />
                                {t.label}
                            </span>
                        ))}
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
